export const HOME_PAGE_SECTION_DEFINITIONS = [
    {
        key: "trending",
        label: "Trending Now",
        description: "Books shown in the Trending Now carousel.",
        defaultItemLimit: 8,
    },
    {
        key: "category",
        label: "Explore By Category",
        description: "Books available inside the category section tabs.",
        defaultItemLimit: 5,
    },
    {
        key: "topRated",
        label: "Top Rated",
        description: "Books shown in the Top Rated carousel.",
        defaultItemLimit: 8,
    },
    {
        key: "editorsPick",
        label: "Editor's Pick",
        description: "Books shown in the Editor's Pick carousel.",
        defaultItemLimit: 8,
    },
    {
        key: "authors",
        label: "Featured Authors",
        description: "Authors shown in the Author section.",
        defaultItemLimit: 10,
    },
];

export const HOME_PAGE_SECTION_DEFAULTS = HOME_PAGE_SECTION_DEFINITIONS.reduce((acc, section) => {
    acc[section.key] = {
        sectionKey: section.key,
        itemLimit: section.defaultItemLimit,
        bookIds: [],
        isActive: true,
    };
    return acc;
}, {});

export function normalizeHomepageSections(rawSections) {
    return HOME_PAGE_SECTION_DEFINITIONS.reduce((acc, section) => {
        const incoming = rawSections?.[section.key] || {};
        const bookIds = Array.isArray(incoming.bookIds)
            ? [...new Set(incoming.bookIds.map((bookId) => String(bookId ?? "").trim()).filter(Boolean))]
            : [];
        const parsedLimit = Number(incoming.itemLimit);

        acc[section.key] = {
            sectionKey: section.key,
            itemLimit: Number.isFinite(parsedLimit) && parsedLimit > 0
                ? Math.floor(parsedLimit)
                : section.defaultItemLimit,
            bookIds,
            isActive: incoming.isActive !== undefined ? Boolean(incoming.isActive) : true,
        };

        return acc;
    }, {});
}

export function buildManualSectionBooks(allBooks = [], sectionConfig = {}) {
    const ids = Array.isArray(sectionConfig.bookIds) ? sectionConfig.bookIds : [];
    if (!ids.length) return [];

    const byId = new Map(
        allBooks.map((book) => [String(book?._id ?? book?.id ?? ""), book])
    );

    return ids
        .map((id) => byId.get(String(id)))
        .filter(Boolean);
}
